module.exports = __webpack_public_path__ + "img/oeillet_de_poete.acf2d428.jpg";